import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { UserContext } from "../../App";
import {
  createVehicle,
  deleteVehicle,
  updateVehicle,
} from "../../utils/vehicle";
import { db } from "../../index";
import Select from "react-select";
import { useCompanyOptions } from "../../utils/company";
import { FooterActionsContainer } from "../layout/Footer";
import { OutlineButton } from "../layout/OutlineButton";

export default function VehicleAddOrUpdateContent() {
  const history = useHistory();
  const params = useParams();
  const vehicleId = params.vehicle_id;

  const { userInfos } = useContext(UserContext);

  const companyOptions = useCompanyOptions();

  const [isFetching, setIsFetching] = useState(false);
  const [formError, setFormError] = useState([]);
  const [vehicle, setVehicle] = useState({
    brand: "",
    model: "",
    plateNumber: "",
    company: {
      name: "",
      id: "",
    },
  });

  function handleCompanyChange(obj) {
    setVehicle((old) => ({
      ...old,
      company: {
        ...obj.data,
        key: obj.data.id,
      },
    }));
  }

  useEffect(() => {
    if (vehicleId && userInfos?.uid) {
      db.ref(`users/${userInfos.uid}/vehicle/${vehicleId}`)
        .once("value", (snapshot) => {
          const res = snapshot.val();
          setVehicle({ ...res, id: snapshot.key });
        })
        .then();
    }
  }, [vehicleId, userInfos?.uid]);

  function handleChange(e) {
    const { name, value } = e.target;
    setVehicle((old) => ({
      ...old,
      [name]: value,
    }));
  }

  async function handleDeleteVehicle() {
    await deleteVehicle(userInfos, vehicleId);
    history.push("/vehicle");
  }

  async function handleFormSubmit(e) {
    e.preventDefault();
    if (handleValidation()) {
      setIsFetching(true);

      if (vehicleId) {
        await updateVehicle(userInfos, vehicle);
        window.alert("Véhicule mis à jour avec succès");
      } else {
        await createVehicle(userInfos, vehicle);
        history.push("/vehicle");
      }

      setIsFetching(false);
    }
  }

  function handleValidation() {
    let valid = true;
    let message = [];

    if (!vehicle.brand) {
      valid = false;
      message.push("Veuillez renseigner la marque du véhicule");
    }

    if (!vehicle.model) {
      valid = false;
      message.push("Veuillez renseigner le modèle du véhicule");
    }

    if (!vehicle.plateNumber) {
      valid = false;
      message.push(
        "Veuillez renseigner la plaque d'immatriculation du véhicule"
      );
    }

    setFormError(message);
    return valid;
  }

  const FormAlert = useMemo(() => {
    return formError.length > 0 ? (
      <div
        className="alert alert-danger mt-3"
        role="alert"
        style={{ flexDirection: "column", borderRadius: "0" }}
      >
        {formError.map((error, index) => {
          return (
            <div
              className="alert-text"
              key={index}
              style={{ alignSelf: "flex-start" }}
            >
              {error}
            </div>
          );
        })}
      </div>
    ) : null;
  }, [formError]);

  const buttonText =
    isFetching === true ? (
      <button type="submit" className="btn btn-primary px-5" disabled>
        {vehicleId ? "Mise à jour..." : "Création..."}
      </button>
    ) : (
      <button type="submit" className="btn btn-primary px-5">
        {vehicleId ? "Mettre à jour le véhicule" : "Créer le véhicule"}
      </button>
    );

  return (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader   kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">
              {vehicleId ? vehicle?.name : "Ajouter un véhicule"}{" "}
            </h3>
            <div className="kt-subheader__breadcrumbs">
              <Link to="/" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter"></i>
              </Link>
              <span className="kt-subheader__breadcrumbs-separator"></span>
              <Link to="/vehicle/" className="kt-subheader__breadcrumbs-link">
                Véhicules
              </Link>
              {vehicleId ? (
                <>
                  <span className="kt-subheader__breadcrumbs-separator"></span>
                  <Link
                    to={"/vehicle/" + vehicleId}
                    className="kt-subheader__breadcrumbs-link"
                  >
                    {vehicle.name}
                  </Link>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet kt-portlet--tabs">
          <div className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title">Données du véhicule</h3>
            </div>
          </div>
          <form onSubmit={handleFormSubmit} className="kt-form">
            <div className="kt-portlet__body">
              <div className="kt-section kt-section--first">
                <div className="kt-section__body">
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Marque:</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="brand"
                        value={vehicle.brand}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Modèle:</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="model"
                        value={vehicle.model}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">
                      Immatriculation:
                    </label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="plateNumber"
                        value={vehicle.plateNumber}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">
                      Compagnie:
                    </label>
                    <div className="col-lg-6">
                      <Select
                        options={companyOptions}
                        onChange={handleCompanyChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-lg-3"></div>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="company"
                        value={vehicle?.company?.name}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <FooterActionsContainer>
              <div>
                <OutlineButton type="button" onClick={history.goBack}>
                  <i className="fas fa-arrow-left"></i>
                  Retour
                </OutlineButton>
              </div>
              <div>{buttonText}</div>
              <div>
                {vehicleId && (
                  <OutlineButton
                    type="button"
                    data-toggle="modal"
                    data-target="#delete_modal"
                  >
                    <i className="fas fa-trash" />
                    Supprimer
                  </OutlineButton>
                )}
              </div>
            </FooterActionsContainer>
          </form>
          {FormAlert}
        </div>
      </div>
      <div
        className="modal fade"
        id="delete_modal"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Supprimer le véhicule
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Êtes-vous sûr de vouloir supprimer le véhicule ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Annuler
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={handleDeleteVehicle}
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
